/**
 * Generated bundle index. Do not edit.
 */
export { MatChipsModule, MatChipListChange, MatChipList, MatChipSelectionChange, MatChipBase, _MatChipMixinBase, MatBasicChip, MatChip, MatChipRemove, MatChipInput } from './public-api';
//# sourceMappingURL=index.js.map